/**
 * Idle-timeout hook for authenticated routes. Mounts a `react-idle-timer`
 * watcher and redirects to `/logout` after N minutes of inactivity.
 * `idleTimeoutMins` comes from the tenant payload via session storage,
 * defaulting to 60.
 */

import { useIdleTimer } from 'react-idle-timer'
import { useNavigate } from 'react-router-dom'
import { getIdleTimeoutMins, isValidSession } from '@services/session'

export function useIdleLogout(): void {
  const navigate = useNavigate()
  const enabled = isValidSession()
  const timeoutMs = getIdleTimeoutMins() * 60_000

  useIdleTimer({
    timeout: timeoutMs,
    disabled: !enabled,
    debounce: 500,
    crossTab: true,
    onIdle: () => {
      navigate('/logout', { replace: true })
    },
  })
}
